import { useId } from 'react'
import { useTranslation } from 'react-i18next'
import { CurecallInputLabel, CurecallToggle } from '@honestica/curecall-ui'
import { type TDelayState } from '../../node.type'
import { DurationInputFields } from 'src/components/duration-input-fields/duration-input-fields.component'

interface ShowInDashboardFieldsProps {
  isEnabled: boolean
  onEnabledChange: (isEnabled: boolean) => void
  delay: TDelayState
  onDelayChange: (delay: TDelayState) => void
}

export function ShowInDashboardFields({
  isEnabled,
  onEnabledChange,
  delay,
  onDelayChange,
}: ShowInDashboardFieldsProps) {
  const { t } = useTranslation()
  const delayId = useId()

  return (
    <div className="c-flex c-flex-col c-gap-3">
      <CurecallToggle
        leftLabel={t('pages.configuration.followups.chatbot.conditional-sections.display-in-dashboard')}
        isEnabled={isEnabled}
        onChange={onEnabledChange}
      />

      {isEnabled && (
        <div className="c-flex c-flex-col c-gap-1 c-pl-6 c-border-l-2 c-border-gray-300">
          <CurecallInputLabel
            id={delayId}
            label={t('pages.configuration.followups.chatbot.node-form.human-review-request-delay')}
            isRequired={true}
            tooltipContent={t(
              'pages.configuration.followups.chatbot.node-form.human-review-request-delay-tooltip',
            )}
            tooltipPosition="right"
          />
          <DurationInputFields delay={delay} onDelayChange={onDelayChange} />
        </div>
      )}
    </div>
  )
}
